import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateExtraInfomation } from "mobx-stores/_models/employee/extra-infomation";
import { number, string } from "yup";
import {
  searchEmploymentStatusOptions,
  searchRecruitmentSourceOptions,
} from "../auto-complete-options";
export const getExtraInfoFormSchema =
  (): ObjectSchemaType<IUpdateExtraInfomation> => ({
    employmentStartDate: {
      label: "Ngày Tuyển Dụng",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string().required(),
    },
    birthDate: {
      label: "Ngày Sinh",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    nationalIDNumber: {
      label: "Số Thẻ CC",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(255).required(),
    },
    nationalIDIssueDate: {
      label: "Ngày Cấp CC",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    nationalIDAddress: {
      label: "Địa Chỉ",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(512),
    },
    registeredHometown: {
      label: "Nguyên Quán",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    birthCertificatePlace: {
      label: "Nơi Cấp Giấy Khai Sinh",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    phoneNumber: {
      label: "Số ĐT",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(16),
    },
    email: {
      label: "Email",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(255),
    },
    bankAccountNumber: {
      label: "Số Tài Khoản",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(20),
    },
    contact: {
      label: "Liên Hệ Khác",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(255),
    },
    recruitmentSourceType: {
      label: "Nguồn Tuyển",
      type: InputType.autoComplete,
      gridSize: 6,
      validattionYupSchema: number(),
      metaData: {
        searchOptionItemsAsync: searchRecruitmentSourceOptions,
      },
    },
    internalRelationship: {
      label: "Quan Hệ Nội Bộ",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string().max(255),
    },
    status: {
      label: "Trạng Thái",
      type: InputType.autoComplete,
      gridSize: 6,
      validattionYupSchema: number(),
      metaData: {
        searchOptionItemsAsync: searchEmploymentStatusOptions,
      },
    },
    leavingDate: {
      label: "Ngày Thôi Việc",
      type: InputType.datePicker,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    leavingReason: {
      label: "Lý Do Thôi Việc",
      type: InputType.text,
      gridSize: 6,
      validattionYupSchema: string(),
    },
    note: {
      label: "Ghi Chú",
      type: InputType.textArea,
      gridSize: 12,
      validattionYupSchema: string(),
    },
  });
